import { storeActions } from '@/store/actions'
import { isAnyOf, UnknownAction } from '@reduxjs/toolkit'
import { createReducer } from '@reduxjs/toolkit/react'
import { AlertStatus } from '@repo/shared/dtos/alert'
import { TimeType } from '@repo/shared/dtos/generic'
import { AsyncData, DataStatus } from '@repo/ui/utils'

export type Alert = {
  id: string
  createdAt: TimeType
  statusChangedAt: TimeType
  title: string
  content: string
  status: AlertStatus
  beneficiaryId: string
  caseWorkerId: string
  chatSessionId: string
  chatMessageId?: string
}

export type AlertState = {
  all: AsyncData<Alert[]>
}

export const alertInitialState: AlertState = {
  all: DataStatus.Uninitialized,
}

export const alertReducer: ((
  state: AlertState | undefined,
  action: UnknownAction,
) => AlertState) & {
  getInitialState: () => AlertState
} = createReducer(alertInitialState, (builder) => {
  // Organization
  builder
    .addCase(storeActions.cleanUpOrganization, () => {
      return alertInitialState
    })
    .addCase(
      storeActions.initOrganization.pending,
      (
        state,
        {
          meta: {
            arg: { isSameOrganization },
          },
        },
      ) => {
        if (isSameOrganization) return
        state.all = DataStatus.Loading
      },
    )
    .addCase(storeActions.initOrganization.rejected, (state) => {
      state.all = DataStatus.Error
    })
    .addCase(
      storeActions.initOrganization.fulfilled,
      (state, { payload: { alerts } }) => {
        // Unread alerts first
        state.all = [...alerts].sort((a, b) => {
          if (a.status === b.status) return 0
          return a.status === AlertStatus.UNREAD &&
            (b.status === AlertStatus.READ || b.status === AlertStatus.ARCHIVED)
            ? -1
            : 1
        })
      },
    )

  builder.addMatcher(
    isAnyOf(
      storeActions.assistant.alert.markAs.read.fulfilled,
      storeActions.assistant.alert.markAs.archived.fulfilled,
    ),
    (state, { payload: { alert } }) => {
      if (!DataStatus.isFulfilled(state.all)) return
      state.all = state.all.map((a) => (a.id === alert.id ? alert : a))
    },
  )
})
